module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_TottenhamHotspur.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_TottenhamHotspur.png
// module id = 2092
// module chunks = 4